import { useMutation } from '@apollo/client';
import { DeleteConversationDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import type { DeleteConversationTRPCInput } from './useDeleteConversationTRPC';
import { useDeleteConversationTRPC } from './useDeleteConversationTRPC';

/**
 * Flag-gated wrapper (RSP-6496). The compound delete (comments then the
 * conversation) returns `{ Id }` from both paths.
 */
export const useDeleteConversation = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteConversationGraphQL, graphqlState] = useMutation(
    DeleteConversationDocument
  );

  const trpcMutation = useDeleteConversationTRPC();

  const deleteConversation = async (
    input: DeleteConversationTRPCInput
  ): Promise<{ Id: string }> => {
    if (trpcEnabled) {
      return trpcMutation.deleteConversation(input);
    }

    await deleteConversationGraphQL({
      variables: { Id: input.Id },
    });

    return { Id: input.Id };
  };

  if (trpcEnabled) {
    return {
      deleteConversation,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteConversation,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
